const colors = {
    // #van del más brillante al más cercano a blanco
    rosado: {
        original: '#ff66c4',
        normal: '#FF8CD3',
        claro: '#FFC6E9',
        muy_claro: '#FFECF8'
    },
    celeste: {
        original: '#5CE1E6',
        normal: '#99ECEF',
        claro: '#C2F4F6',
        muy_claro: '#EBFBFC'
    },
    amarillo: {
        original: '#FFBD59',
        normal: '#FFCE83',
        claro: '#FFE6C1',
        muy_claro: '#FFF7EA'
    },
    verde: {
        fondo: "#74aa8c",
        letras: "#C0D8CB"
    },
    rojo: {
        fondo: "#D88391",
        letras: "#EBC1C8"
    },
    //colores para usar los colores en schema
    //brandPrincipal = Rosado
    //brandSecundario = Celeste
    //brandTerciario = Amarillo
    brandPrincipal: {
        "50": "#FFE5F5",
        "100": "#FFB8E3",
        "200": "#FF8AD2",
        "300": "#FF5CC0",
        "400": "#FF2EAE",
        "500": "#FF009D",
        "600": "#CC007D",
        "700": "#99005E",
        "800": "#66003F",
        "900": "#33001F"
    },
    brandSecundario: {
        "50": "#E9FBFC",
        "100": "#C1F4F6",
        "200": "#99ECEF",
        "300": "#72E5E9",
        "400": "#4ADEE3",
        "500": "#22D6DD",
        "600": "#1BABB1",
        "700": "#148185",
        "800": "#0E5658",
        "900": "#072B2C"
    },
    brandTerciario: {
        "50": "#FFF5E5",
        "100": "#FFE3B8",
        "200": "#FFD08A",
        "300": "#FFBE5C",
        "400": "#FFAC2E",
        "500": "#FF9A00",
        "600": "#CC7B00",
        "700": "#995C00",
        "800": "#663D00",
        "900": "#331F00"
    }
}

export default colors